var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.ohsAssetsContainer},[_c('ul',{class:[_vm.$style.ohsAssetsWrapper]},_vm._l((_vm.selectedOhsAssets),function(assets){return _c('li',{key:assets.id,staticClass:"flex-item",class:[_vm.$style.ohsAssetsList]},[_c('img',{attrs:{"src":assets.ohsImagePath}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }